import './polyfills';

import 'zone.js';
import 'reflect-metadata';

if (!Element.prototype.matches && (Element.prototype as any).msMatchesSelector) {
    Element.prototype.matches = (Element.prototype as any).msMatchesSelector;
}
